'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const InlineImageProcessingBanner = ({
  imagesToProcess,
  setShowInlineProcessingBanner
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    type: "warning",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.inlineImagesProcessingBanner.title",
      options: {
        imagesToProcess
      }
    }),
    closeable: true,
    onClose: () => setShowInlineProcessingBanner(false),
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-message-history.common-message.inlineImagesProcessingBanner.description"
    })
  });
};
InlineImageProcessingBanner.displayName = 'InlineImageProcessingBanner';
InlineImageProcessingBanner.propTypes = {
  imagesToProcess: PropTypes.string,
  setShowInlineProcessingBanner: PropTypes.func.isRequired
};
export default InlineImageProcessingBanner;